import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { FinancialTab } from '@/features/deals';
import { DealStaffCommission } from '@/features/staff-commission';

export const Route = createFileRoute('/_app/deals/$dealId/financial')({
  beforeLoad: ({ context }) =>
    requirePermission(context.queryClient, 'deal.financials.view', 'Deal financials'),
  component: function Tab() {
    const { dealId } = Route.useParams();
    // Composed at the route: deals never imports staff-commission (no feature edge needed).
    return <FinancialTab dealId={dealId} staffCommission={<DealStaffCommission dealId={dealId} />} />;
  },
});
